import React, { useContext } from 'react';
import DealerAd from '../../../../DealerAd';
import { ThemeOptions, ThemeContext, } from '@wix/da-react-context/pkg/ThemeContext';
import { useInView } from 'react-intersection-observer';
import s from './Dealer.scss';
var REAL_ESTATE_ID_DARK = '150a7c06-b63c-40d0-9d26-7ce399ee49e9';
var REAL_ESTATE_ID_LIGHT = '856b5f3f-b93b-40cc-b7ba-66c8221a398a';
var Dealer = function () {
    var theme = useContext(ThemeContext);
    var _a = useInView({
        threshold: 0,
    }), ref = _a.ref, inView = _a.inView;
    var realEstateId = theme === ThemeOptions.DARK ? REAL_ESTATE_ID_DARK : REAL_ESTATE_ID_LIGHT;
    return (React.createElement("div", { ref: ref, className: s['root'] }, inView && React.createElement(DealerAd, { realEstateId: realEstateId, className: s['root'] })));
};
Dealer.displayName = 'Dealer';
export default Dealer;
//# sourceMappingURL=Dealer.js.map